import { render, staticRenderFns } from "./PaymentSearch.vue?vue&type=template&id=74bd56ba&"
import script from "./PaymentSearch.vue?vue&type=script&lang=js&"
export * from "./PaymentSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports